import { Component } from '@angular/core';
import { AbstractWidgetComponent } from '@sdbn/common';

@Component({
  selector: 'yard-vehicle-archive-administration-widget',
  standalone: false,
  templateUrl: './vehicle-archive-administration-widget.component.html',
  styleUrl: './vehicle-archive-administration-widget.component.scss',
})
export class VehicleArchiveAdministrationWidgetComponent extends AbstractWidgetComponent {

}
